var _style, _defs, _polygon, _defs2, _polygon2, _defs3, _polygon3, _g, _g2, _g3, _path, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtrOptimaColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 355 246",
    style: {
      enableBackground: "new 0 0 355 246"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);}\n\t.st1{clip-path:url(#SVGID_5_);fill:url(#SVGID_6_);}\n\t.st2{clip-path:url(#SVGID_8_);fill:url(#SVGID_9_);}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#0B6FB2;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#1C3B6B;}\n\t.st5{fill:#1C3B6B;}\n\t.st6{fill:url(#SVGID_10_);}\n\t.st7{fill:#1A3C6B;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M168.6,113.5c-48.2-4.6,32-86-12.6-99.5C166.6,44.6,121.4,112.6,168.6,113.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -56.9437,
    y1: 376.438,
    x2: -56.0736,
    y2: 376.438,
    gradientTransform: "matrix(11.3868 39.2211 39.2211 -11.3868 -13954.2705 6581.8301)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#22BDEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#04689A"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "196,-7.7 228.6,105.7 128.3,135.2 95.7,21.7  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_4_",
    d: "M160.9,114.9c-42.4-10.6,11.2-68.7-29.3-81.4C144.5,61.6,121.5,112.1,160.9,114.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -57.0661,
    y1: 375.6336,
    x2: -56.1961,
    y2: 375.6336,
    gradientTransform: "matrix(8.4342 24.8808 24.8808 -8.4342 -8720.7021 4658.5601)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1782C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0E529E"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "166.6,17.1 196.6,106.6 124.1,131.4 94,42  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M155.2,121.1c9.4-0.4,13.1-2.5,20.7-7.6c3.8-2.6,7.5-1.5,11.8-0.4c2.8,0.7,5.8,1.4,9.4,1.2 c-8.9-0.2-12.3-9-21-4.3c-6.7,3.6-11.8,8.3-23.9,5.6c-5.5-1.2-9.5-3.4-14-8.9c-0.1-0.1-0.2-0.3-0.4-0.5 c-10.6-13.7-5.1-44-5.1-44C111.6,94.1,126.3,122.2,155.2,121.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -58.231,
    y1: 377.3419,
    x2: -57.3689,
    y2: 377.3419,
    gradientTransform: "matrix(41.8945 11.5274 11.5274 -41.8945 -1774.9569 16566.7812)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D5DA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#18456A"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "117.6,40.2 212.2,66.5 191,144.3 96.4,118  "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M99,115.9c-16-16.6-31.9-31.8-71-10.8C55.6,97.3,78.5,106,99,115.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M177.2,123.6c-25.9,22.2-49.8,6.1-78.2-7.7c22.6,24,57.4,41.1,83.4,8.5c3.7-4.6,7.7-8.8,15.7-9.1 C198,115.3,189.4,113.2,177.2,123.6"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M66.1,133c10.9,0,19.7,3.3,26.4,9.9c6.7,6.6,10,15.2,10,25.9c0,11.6-3.5,21.5-10.4,29.5 c-6.7,7.9-16,11.8-27.8,11.8c-11.3,0-20.3-3.4-27.1-10.3c-6.8-6.9-10.2-16-10.2-27.5c0-4.9,0.9-9.8,2.6-14.7c1.7-4.9,4-9,7-12.2 c3.4-3.9,7.7-6.9,12.9-9.1C54.7,134.1,60.2,133,66.1,133 M62.3,137c-7,0-12.5,2.7-16.4,8.1c-3.9,5.4-5.9,12.9-5.9,22.5 c0,11.4,2.5,20.6,7.4,27.7c5,7.1,11.4,10.7,19.3,10.7c7.2,0,12.9-2.9,17.2-8.8c4.3-5.9,6.4-13.7,6.4-23.6c0-5.7-1-11.2-3-16.6 c-2-5.4-4.6-9.7-8-12.9C74.6,139.4,68.9,137,62.3,137"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M108.6,214.9v-37l0.1-2.3l-0.3-2.4c-0.5-2.1-1.9-3.1-4.2-3.2c-0.4,0-0.7,0-1.1,0.1l-0.5,0.1 c-0.7,0-1-0.5-1-1.3c0-0.8,0.3-1.2,1-1.4l2.5-0.4c4.5-0.8,7.8-2,10.1-3.7c1.7-1.3,2.8-1.9,3.1-1.9c0.5,0,0.8,0.4,0.8,1.2 l0.1,1.6v4.4c0.2,0.8,0.6,1.2,1,1.2c0.2,0,0.5-0.2,0.9-0.5c3.4-2.8,5.9-4.6,7.6-5.4c1.7-0.8,3.7-1.2,6.1-1.2 c5.3,0,9.6,1.9,12.9,5.7c3.3,3.8,5,8.6,5,14.6c0,8.6-2.6,15.6-7.8,20.8c-4.2,4.2-8.7,6.3-13.6,6.3c-4.6,0-8-0.6-10.3-1.8 c-0.4-0.2-0.7-0.3-0.9-0.3c-0.5,0-0.8,0.7-0.8,2v4.8c0,3.2,0.5,5.5,1.6,6.8c1.1,1.3,3.2,2.1,6.2,2.5c1.3,0.2,2,0.6,2,1.5 c0,1.2-0.6,1.7-1.7,1.7c-0.6,0-1.2-0.1-1.9-0.3c-2.8-0.7-5.1-1-7.1-1c-1.3,0-3.1,0.1-5.7,0.3l-4.5,0.4c-1.1,0.1-1.8,0.1-2.2,0.1 c-1.3,0-2-0.5-2-1.5c0-0.7,0.5-1.2,1.4-1.5c1.4-0.5,2.3-1.3,2.7-2.3C108.4,220.3,108.6,218.1,108.6,214.9 M119.1,175.7v21 c0,2.3,1.4,4.5,4.3,6.6c2.8,2.1,5.9,3.1,9.2,3.1c3.5,0,6.2-1.4,8.3-4.3c2.1-2.8,3.1-6.6,3.1-11.4c0-5.8-1.6-10.7-4.7-14.7 c-3.1-4-6.9-6-11.4-6c-2.4,0-4.5,0.6-6.2,1.7C120,172.8,119.1,174.1,119.1,175.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M167.8,169.5V196c0,3.2,0.5,5.5,1.4,6.7c0.9,1.3,2.6,1.9,4.9,1.9c0.9,0,2.1-0.2,3.6-0.7 c1.5-0.5,2.6-1,3.2-1.5c0.4-0.3,0.7-0.4,0.8-0.4c0.4,0,0.7,0.4,0.8,1.1l0.1,0.5l-0.6,0.9c-3.8,3.7-8.3,5.5-13.4,5.5 c-3.9,0-6.8-0.9-8.6-2.8c-1.8-1.8-2.8-4.7-2.8-8.6v-29.2H154c-1.7,0-2.5-0.5-2.5-1.4c0-0.6,0.4-1.2,1.3-1.8c1.5-1,3.7-3.1,6.5-6 c2.8-3,4.7-5.2,5.6-6.8c1.1-1.8,1.9-2.6,2.4-2.6c0.3,0,0.4,0.3,0.5,0.8v12.6h7.6c1.4,0,2.4-0.2,3-0.7l1.4-0.9 c0.3-0.2,0.6-0.3,0.9-0.4c0.6,0,0.9,0.3,0.8,0.9c0,0.3-0.2,0.7-0.4,1.2c-0.2,0.4-0.4,1.2-0.6,2.4c-0.4,1.9-1.3,2.8-2.9,2.8 H167.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M196.1,165.1v30.7c0,3.7,0.5,6.2,1.6,7.7c1.1,1.4,3,2.3,5.9,2.4c1.2,0.1,1.7,0.5,1.7,1.3 c0,1-1.4,1.4-4.1,1.4c-0.3,0-1.1,0-2.3-0.2L195,208c-2.2-0.2-3.6-0.3-4.3-0.3c-1.9,0-4.4,0.3-7.5,0.8c-0.8,0.1-1.4,0.2-1.8,0.2 c-0.7,0-1.1-0.4-1.1-1.1c0-0.5,0.2-0.9,0.7-1.1l1.8-0.9c0.8-0.4,1.4-1.3,2-2.8c0.5-1.5,0.8-3,0.8-4.7l-0.1-2.3v-18.3 c0-2.8-0.3-4.8-0.9-5.8c-0.6-1.1-1.6-1.6-3.1-1.6h-1.2c-0.7,0-1.1-0.1-1.4-0.4c-0.1-0.1-0.2-0.4-0.2-0.8c0-0.9,1.1-1.6,3.2-2.1 c5.3-1.2,9.5-2.9,12.5-5.3c0.4-0.3,0.7-0.4,0.9-0.4c0.5,0,0.7,0.4,0.7,1l-0.1,0.5C196.1,163,196.1,163.8,196.1,165.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M277.5,182.9V198c0,2.8,0.4,4.7,1.3,5.8c0.9,1.1,2.5,1.8,4.9,2.1c1.2,0.2,1.8,0.7,1.8,1.5 c0,1-0.5,1.4-1.6,1.4c-1.3,0-3.7-0.3-7.5-0.9c-1.9-0.3-3.4-0.4-4.5-0.4c-1.5,0-3.7,0.3-6.7,0.8c-1,0.2-1.7,0.3-2.2,0.3 c-0.6,0-0.9-0.4-0.9-1.1c0-0.5,0.4-1,1.1-1.4c1.5-0.8,2.5-1.6,3-2.3c0.4-0.7,0.7-1.9,0.7-3.5l-0.1-2.6v-14.8 c0-4.9-0.8-8.6-2.4-10.9c-1.6-2.3-4.1-3.5-7.5-3.5c-2.6,0-4.8,0.8-6.4,2.3c-1.7,1.5-2.5,3.5-2.5,5.8v19.5c0,3.5,0.5,6,1.5,7.4 c1,1.4,2.9,2.2,5.6,2.5c1.3,0.1,1.9,0.6,1.9,1.4c0,1-0.6,1.5-1.9,1.5c-1.5,0-4-0.3-7.4-0.8c-2.2-0.3-4-0.4-5.5-0.4 c-1.2,0-3,0.2-5.6,0.7c-0.9,0.1-1.7,0.2-2.4,0.3c-0.9,0-1.4-0.4-1.4-1.2c0-0.6,0.3-1.1,0.8-1.3c1.6-0.7,2.7-1.5,3.2-2.4 c0.5-0.9,0.8-2.4,0.8-4.4l-0.1-2.3v-14c0-4.9-0.8-8.6-2.2-10.9c-1.5-2.3-3.8-3.5-7-3.5c-2.8,0-5,0.9-6.8,2.7 c-1.8,1.8-2.7,4.1-2.7,6.8v19.6c0,2.6,0.5,4.4,1.4,5.4c0.9,1,2.9,1.9,6,2.7c1.1,0.3,1.6,0.7,1.7,1.4c0,0.9-0.6,1.3-1.8,1.3 c-0.9,0-1.9-0.1-3-0.2l-4.7-0.5c-2-0.2-3.7-0.3-5.2-0.3c-2.2,0-4.3,0.2-6.2,0.7c-0.9,0.2-1.6,0.3-2.1,0.3c-1,0-1.5-0.4-1.5-1.3 c0-0.5,0.3-0.9,1-1.2c1.4-0.7,2.4-1.5,2.9-2.5c0.6-1,0.8-2.4,0.8-4.2l0.1-2.9v-19.4c0-3.2-0.3-5.3-1-6.2 c-0.7-0.9-2.2-1.4-4.6-1.4c-0.9,0-1.3-0.4-1.3-1.2c0-0.9,0.9-1.5,2.6-1.8l4.3-1.4l3-1c1.8-0.6,3.8-1.6,6-3.2 c0.3-0.2,0.5-0.3,0.7-0.3c0.6,0,0.8,0.4,0.8,1.2l-0.1,1.4l-0.2,3.6c0,0.4-0.1,0.8-0.1,1.2c0,1.4,0.3,2.1,0.9,2.2 c0.2,0,0.5-0.2,0.7-0.5l2.2-2.5c3-3.4,6.6-5.2,11-5.2c2.3,0,4.7,0.8,7.3,2.4c2.5,1.6,4.1,3.4,4.8,5.3c0.4,1.2,0.7,1.7,0.9,1.7 c0.2,0,0.5-0.4,1.1-1.1c1.7-2.5,4-4.6,6.7-6.1c2.7-1.5,5.4-2.3,8-2.3C272.3,162.3,277.5,169.1,277.5,182.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M307.7,182.7c0.4-1.6,0.6-3.1,0.6-4.2c0-3.6-0.8-6.6-2.5-8.9c-1.7-2.3-3.8-3.4-6.5-3.4c-3.4,0-5,1.4-5,4.3 c0,0.5,0,1.1,0.1,1.6l0.2,1c0,2.4-2.7,3.7-8.1,3.7c-1.4,0-2.1-0.6-2-1.9c0-0.3,0.1-0.7,0.3-1.2c0.1-0.4,0.2-0.9,0.3-1.4 c0.5-2.3,1.5-4.1,3.2-5.3c3.7-2.7,8.2-4.1,13.4-4.1c6,0,10.6,1.4,13.6,4.3c2.3,2.2,3.5,6,3.5,11.5c0,2.7-0.1,6.2-0.3,10.4 c-0.2,4.8-0.3,7.9-0.3,9.5c0,3.7,1.4,5.6,4.3,5.6c1,0,1.8-0.1,2.2-0.4c0.6-0.3,1-0.4,1.2-0.4c0.5,0,0.7,0.3,0.7,0.8 c0,0.9-0.7,1.8-2,2.5l-2,1.1l-1.8,1.1c-1.3,0.7-2.6,1-4.1,1c-3.1,0-5.7-2.1-7.7-6.2c-6.5,4.3-11.9,6.5-16.2,6.5 c-3,0-5.3-0.9-7-2.7c-1.7-1.8-2.5-4.2-2.5-7.4c0-5.7,2.4-9.9,7.2-12.5C293.2,185.9,299.1,184.3,307.7,182.7 M306.7,185.8 c-3-0.2-5.9,0.9-8.6,3.3c-2.7,2.4-4.1,5.1-4.1,8c0,4.8,1.8,7.2,5.5,7.2c2.3,0,4.3-0.6,6-1.7c0.9-0.6,1.6-1.6,1.9-3 c0.3-1.4,0.5-3.7,0.5-7l0.1-4.2v-1.1l-0.3-1.2C307.6,185.9,307.2,185.8,306.7,185.8"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M197.4,147.9c0,3.9-3.1,7.1-7,7.1c-3.9,0-7-3.2-7-7.1c0-3.9,3.1-7.1,7-7.1 C194.2,140.8,197.4,144,197.4,147.9"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: -53.7154,
    y1: 377.1098,
    x2: -53.7154,
    y2: 377.1098,
    gradientTransform: "matrix(41.8945 11.5274 11.5274 -41.8945 -1774.9569 16566.7812)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D5DA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#18456A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M321.8,148.8"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M335.1,160.4c0,4.3-3.3,7.6-7.7,7.6c-4.3,0-7.7-3.3-7.7-7.6c0-4.2,3.4-7.5,7.7-7.5 C331.8,152.9,335.1,156.2,335.1,160.4z M321.6,160.4c0,3.3,2.5,6,5.9,6c3.3,0,5.7-2.7,5.7-6c0-3.3-2.4-6-5.8-6 S321.6,157.1,321.6,160.4z M326.2,164.3h-1.7v-7.5c0.7-0.1,1.6-0.2,2.9-0.2c1.4,0,2.1,0.2,2.6,0.5c0.4,0.3,0.7,0.9,0.7,1.6 c0,0.8-0.6,1.5-1.6,1.7v0.1c0.7,0.3,1.1,0.8,1.4,1.8c0.2,1.1,0.4,1.6,0.5,1.9h-1.9c-0.2-0.3-0.4-1-0.6-1.8 c-0.1-0.8-0.6-1.2-1.6-1.2h-0.8V164.3z M326.3,160.1h0.8c1,0,1.7-0.3,1.7-1.1c0-0.7-0.5-1.1-1.6-1.1c-0.5,0-0.8,0-1,0.1V160.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtrOptimaColor);
export default __webpack_public_path__ + "static/media/OTR_optima_color.d17e90b89bc4486336511c380d3ee256.svg";
export { ForwardRef as ReactComponent };